import SimpleVirtualizedVehicleList from '@/components/ui/vehicle-list/simple-virtualized-vehicle-list';
import { useVehiclesContext } from '@/contexts/vehicles-provider';
import { createFileRoute } from '@tanstack/react-router';
import { observer } from 'mobx-react-lite';

const PendingPage = observer(() => {
  const { pendingVehicles, searchFilterCallback } = useVehiclesContext();
  return (
    <div>
      <SimpleVirtualizedVehicleList
        vehicleListingsData={pendingVehicles}
        filterCallback={() => true}
        findInViewFilterCallback={searchFilterCallback}
        enableScope={() => {}}
      />
    </div>
  );
});

export const Route = createFileRoute('/(authenticated)/cars/pending/')({
  component: PendingPage,
});
